<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
    </div>
    <div class="icerik">
      <BinaOzetEkran :data="BinaOzetEkranData"></BinaOzetEkran>
    </div>
  </div>
</template>

<script>
  import BinaOzetEkran from "../../../components/Pack/Yonetim/bina/Ekran/BinaOzetEkran";
  export default {
    components: {BinaOzetEkran},
    data() {
      return {
        BinaOzetEkranData: {
          id: "Sirket"
        },
        Sayfa: {
          Button: null,
          Adi: this.$t('mYonetim.7'),
          Menu: [
            {Adi: this.$t('mYonetim.9'), Link: '/yonetim/sirket/teklif'}
          ],
          MenuDisplay: true
        },
        Bilgiler: [
          {Text: this.$t('eYonetim.0'), Sayi: 0, Class: ''},
          {Text: this.$t('eYonetim.1'), Sayi: 0, Class: ''},
          {Text: this.$t('eYonetim.2'), Sayi: 0, Class: ''},
          {Text: this.$t('eYonetim.3') + ' & ' + this.$t('eYonetim.4'), Sayi: 0, Class: ''},
          {Text: this.$t('eYonetim.5'), Sayi: 0, Class: 'danger'},
          {Text: this.$t('eYonetim.6'), Sayi: 0, Class: 'danger'}
        ],

      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'yonetim/sirket/ekran'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.Bilgiler[0].Sayi = response.Liste.Site;
              this.Bilgiler[1].Sayi = response.Liste.Bina;
              this.Bilgiler[2].Sayi = response.Liste.Mesken;
              this.Bilgiler[3].Sayi = response.Liste.MalikSakin;
              this.Bilgiler[4].Sayi = response.Liste.Sms;
              this.Bilgiler[5].Sayi = response.Liste.IlgiliKisi;
            } else {
              this.$notie.alert(2, response.Mesaj, 3);
              this.hata = response.Hata;
            }
          })
      },
    },
    created() {
      this.$store.commit("SayfaBilgi", this.Sayfa);
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Yonetim/sirket/Index.vue